module.exports = __webpack_public_path__ + "debian-60c3e279de627b379f339f924fb2a57c.svg";